import "./NlpContainer.css";
import React, {useEffect, useState} from "react";
import NlpChat from "./NlpChat/NlpChat";
import NlpSideBar from "./NlpSideBar/NlpSideBar";

const NlpContainer: React.FC = () => {

    return (
        <div className="NlpContainer">
            <NlpChat></NlpChat>
            <NlpSideBar></NlpSideBar>
        </div>
    );
};

export default NlpContainer;
